import create from 'zustand';
import gsap from 'gsap';

type AnimationStore = {
  loading: GSAPTimeline,
  landing: {
    page: GSAPTimeline,
    somersby: {
      mask: GSAPTimeline,
      container: GSAPTimeline,
      title: GSAPTimeline,
      subtitle: GSAPTimeline
    },
    webgl: {
      fall: GSAPTimeline
    }
  }
}

const useAnimationStore = create<AnimationStore>(set => ({
  loading: gsap.timeline(),
  landing: {
    page: gsap.timeline(),
    somersby: {
      mask: gsap.timeline(),
      container: gsap.timeline(),
      title: gsap.timeline(),
      subtitle: gsap.timeline(),
    },
    webgl: {
      fall: gsap.timeline()
    }
  }
}));

export default useAnimationStore;